export default "__VITE_ASSET__B5sh0Tdm__"